<!--运行记录-->
<template>
<div class="ke">
  <el-carousel ref="kecarousel" @change="carouselChange" :interval="5000" arrow="always" class="ke_carousel">
    <el-carousel-item v-for="(item,index) in keData" :key="index" :name="item.devName">
      <div class="equipment">
        <div class="left">
          <div class="img">
            <img :src="item.imgs"><p>{{item.devName}}</p>
          </div>
          <table>
            <tr>
              <td>运行状态</td>
              <td>{{item.devStatus}}</td>
            </tr>
            <tr>
              <td>启动时间</td>
              <td>{{item.startTime}}</td>
            </tr>
            <tr>
              <td>运行时长</td>
              <td>{{item.runTime}}天</td>
            </tr>
            <tr>
              <td>保养周期</td>
              <td>{{item.cycle}}日/次</td>
            </tr>
            <tr>
              <td>下次保养日</td>
              <td>{{item.nextMaintain}}</td>
            </tr>
            <tr>
              <td>负责人</td>
              <td>{{item.charge}}</td>
            </tr>
          </table>
        </div>
        <div class="right">
          <div :id="'ke_line'+item.id" class="echarts"></div>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</div>
</template>

<script>
import api from '@/apis/device/device'
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
      statusRun:["关机状态","检修状态","低速运转","正常运转","高速运转"],
      keData:[
        {
          id:'',
          devName:'电动固定螺杆空压机LGF-BP-6',
          imgs:require('../assets/images/pic4.png'),
          devStatus:'',
          startTime:'',
          runTime:'',
          cycle:'',
          nextMaintain:'',
          charge:'',
          records:'',
        }
      ],
    }
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //幻灯片切换事件
    carouselChange(val){

      this.$emit('nowName',this.keData[val].devName);

    },
    setActiveItem(v){

      this.$refs.kecarousel.setActiveItem(v)
    },

    //获取数据
    getList(){
      api.getRecord({
        params: {
          limit: 5,
        }
      }).then(res=>{
        if(res.code==10000){
          let _arr = res.data.map(item=>{
            return{
              id:item.id,
              devName:item.devName,
              imgs:item.imgs,
              devStatus:this.statusRun[item.devStatus-1],
              startTime:item.startTime   ,
              runTime:item.runTime,
              cycle:item.cycle,
              nextMaintain:item.nextMaintain,
              charge:item.charge,
              records:item.records,              
            }
          })
          this.keData = _arr
          for (let iterator in _arr) {
            let _time = []
            let _speed = []
            for(let i in _arr[iterator].records){
              _time.push(_arr[iterator].records[i].startTime?_arr[iterator].records[i].startTime:'')
              _speed.push(_arr[iterator].records[i].speed?_arr[iterator].records[i].speed:'')
            }
            this.$nextTick(()=>{
              this.ke_line(_arr[iterator].id,_time,_speed);
            })
          }
        }
      })
    },
    ke_line(id,a,b){
      let ke_line = echarts.init(document.getElementById('ke_line'+id) );
      ke_line.setOption({
          color:['#fff45c','#fac858'],
          tooltip: { 
            trigger: 'axis',
            textStyle:{fontSize:this.$echartsFontSize},
            axisPointer: { type: 'shadow' }
          },
          xAxis: {
              type: 'category',
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize-4,},
              axisLine:{lineStyle:{color:this.axisLineColor}},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
              data: a
          },
          yAxis: {
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize-4},
              axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
              splitLine:{show:true,lineStyle:this.splitLineStyle},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
          },
          grid: { left: '6%',right:'15%',top:'10%',bottom:'0%',containLabel:true},
          series: [{
              type: 'line',
              data: b,
              symbolSize:10, symbol:'circle',
              markLine: {
                  data: [
                      {
                          type: 'average',  symbol: 'none',
                          label: {
                              position: 'end', formatter: '平均速度',fontSize:this.$echartsFontSize-2
                          },
                          lineStyle:{ color:'#ee6666' }
                      },
                      // {
                      //     type: 'average', symbol: 'none',
                      //     label: {
                      //         position: 'end', formatter: '中速区',fontSize:this.$echartsFontSize-2
                      //     },
                      //     lineStyle:{ color:'#fac858' }
                      // },
                      // {
                      //     type: 'average', symbol: 'none',
                      //     label: {
                      //         position: 'end', formatter: '低速区',fontSize:this.$echartsFontSize-2
                      //     },
                      //     lineStyle:{ color:'#5ac12b' }
                      // }
                  ]
              }
          }] 
      })
    },
    
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped> 
.ke{ width:100%; height: 100%; position: relative;
  .ke_carousel{ height: 100%; width:100%;}
  .equipment{ width: 100%; height: 100%; padding:.71rem 2.5rem; display: flex; flex-direction: row; align-items: center; overflow: hidden;
    .left{ width: 50%; height: 100%; display: flex; flex-direction: row; align-items: center; overflow: hidden;padding: 0.25rem;
    border: 1px solid #164777;
      .img{ width: 40%; height: 100%; display: flex; flex-direction: column;position: inherit;position: relative;
        img{ width: 100%; height: 100%; flex: 1; display: block;}
        p{ height: 1.6rem; line-height: 1.6rem; flex-shrink: 0; background: #00000067; text-align: center; font-size: 0.68rem; text-overflow:ellipsis; white-space: nowrap; overflow: hidden;position: absolute;width: 100%;left: 0;bottom: 0;color:#fff;}
      }
      table{ flex: 1; width: 100%; height: 100%; font-size: 0.68rem; border-collapse: collapse;background: #0c1c4aa6;
        tr{ text-align: center;
          td{ table-layout: fixed; border: #1647774d solid 1px;}
          td:first-child{ width:6rem;}
          td:last-child{ text-overflow:ellipsis; white-space: nowrap; overflow: hidden; color: #fff;}
        }
      }
    }
    .right{ flex: 1; width:100%; height: 100%;  overflow: hidden;}
  }
}
</style>